export const secPerBlock = !!process.env.VUE_APP_BSC ? 3 : 15;
